import { AuthConfig } from 'angular-oauth2-oidc';
import { Environment } from '../../../environments/model/environment.model';

export function createAuthCodeFlowConfig(environment: Environment): AuthConfig {

  return {
    issuer: environment.oauth.issuer,
    redirectUri: environment.oauth.redirectUri,
    clientId: environment.oauth.clientId,
    // is needed because our keycloak is an idiot, or in there words:
    /**
     * Some auth servers don't allow using password flow
     * w/o a client secret while the standards do not
     * demand for it. In this case, you can set a password
     * here. As this password is exposed to the public
     * it does not bring additional security and is therefore
     * as good as using no password.
     */
    dummyClientSecret: '**********',
    responseType: 'code',
    scope: 'openid profile email offline_access',
    showDebugInformation: false,
    useSilentRefresh: false,
    sessionChecksEnabled: true,
    timeoutFactor: 0.75,
    requireHttps: environment.oauth.requireHttps ?? true,
  };
}
